/** Dosya detay sayfası — panel SSOT */

import { PANEL } from "./panelTokens";
import { panelTableCardSx } from "./panelCardSx";

/** @deprecated Büyük hero kart — panelFileDetailPageHeaderSx tercih edin */
export const panelFileDetailHeroSx = {
  ...panelTableCardSx,
  overflow: "hidden",
};

/** @deprecated */
export const panelFileDetailHeroHeaderSx = {
  px: { xs: 2, md: 3 },
  py: 2.5,
  borderBottom: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.fill.muted,
  display: "flex",
  flexWrap: "wrap",
  alignItems: { xs: "flex-start", md: "center" },
  justifyContent: "space-between",
  gap: 2,
};

/** @deprecated */
export const panelFileDetailStatGridSx = {
  p: { xs: 2, md: 3 },
};

/** @deprecated */
export const panelFileDetailStatItemSx = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  height: "100%",
};

/** Kompakt sayfa üstü — dosya adı, tarih, özet chip'ler */
export const panelFileDetailPageHeaderSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", md: "flex-start" },
  flexWrap: "wrap",
  gap: 2,
  mb: 2.5,
  pb: 2,
  borderBottom: `1px solid ${PANEL.border}`,
};

export const panelFileDetailFileNameSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  fontSize: { xs: "1.35rem", md: "1.5rem" },
  lineHeight: 1.25,
  wordBreak: "break-word",
};

export const panelFileDetailDateMetaSx = {
  display: "block",
  color: PANEL.text.muted,
  fontSize: "0.8rem",
  fontWeight: 500,
  mt: 0.4,
  lineHeight: 1.45,
};

export const panelFileDetailMetaRowSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 0.75,
  mt: 1.1,
};

export const panelFileDetailCollabStripSx = {
  mt: 1.5,
  pt: 1.25,
  borderTop: `1px solid ${PANEL.border}`,
};

export const panelFileDetailCollabStripLabelSx = {
  color: PANEL.text.muted,
  fontWeight: 700,
  fontSize: "0.72rem",
  letterSpacing: 0.4,
  textTransform: "none",
  display: "block",
  mb: 0.75,
};

export const panelFileDetailSectionCardSx = {
  ...panelTableCardSx,
  mt: 2.5,
};

export const panelFileDetailSectionHeaderSx = {
  px: { xs: 2, md: 2.5 },
  py: 2,
  borderBottom: `1px solid ${PANEL.border}`,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
};

export const panelFileDetailDangerButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  bgcolor: PANEL.danger.main,
  color: "#fff",
  borderRadius: PANEL.radius.input,
  px: 2.5,
  py: 1.1,
  boxShadow: "none",
  "&:hover": {
    bgcolor: PANEL.danger.text,
    boxShadow: "none",
  },
};

export const panelFileDetailOutlineWarningButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: PANEL.radius.input,
  px: 2.5,
  color: PANEL.warning.text,
  borderColor: PANEL.warning.border,
  bgcolor: PANEL.warning.soft,
  "&:hover": {
    bgcolor: PANEL.warning.soft,
    borderColor: PANEL.warning.main,
  },
};

export const panelFileDetailCollabPanelSx = {
  p: 1.5,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
};
